const createTemplateTagElement = ({ name }: { name: string }) => {
  const newSpan = document.createElement('span')!;
  newSpan.textContent = `{{${name}}}`;
  newSpan.style.backgroundColor = 'lightgray';
  newSpan.className = name;
  return newSpan;
};

export default createTemplateTagElement;
